var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoIcon03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M7.50098 1.24805C5.86348 1.24805 4.53223 2.5793 4.53223 4.2168C4.53223 5.82305 5.78848 7.12305 7.42598 7.1793C7.47598 7.17305 7.52598 7.17305 7.56348 7.1793C7.57598 7.1793 7.58223 7.1793 7.59473 7.1793C7.60098 7.1793 7.60098 7.1793 7.60723 7.1793C9.20723 7.12305 10.4635 5.82305 10.4697 4.2168C10.4697 2.5793 9.13848 1.24805 7.50098 1.24805Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6746 8.84648C8.93086 7.68398 6.08711 7.68398 4.33086 8.84648C3.53711 9.37773 3.09961 10.0965 3.09961 10.8652C3.09961 11.634 3.53711 12.3465 4.32461 12.8715C5.19961 13.459 6.34961 13.7527 7.49961 13.7527C8.64961 13.7527 9.79961 13.459 10.6746 12.8715C11.4621 12.3402 11.8996 11.6277 11.8996 10.8527C11.8934 10.084 11.4621 9.37148 10.6746 8.84648Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon03);
export default __webpack_public_path__ + "static/media/video-icon-03.a66b2ccdfc9fb503a39abe0a669b4dee.svg";
export { ForwardRef as ReactComponent };